import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { AlgoMode } from "@front/m19-api-client";
import { CampaignTypeWithTacos, StrategyEx } from "@front/m19-models";
import { CampaignTypeBadgeComponent } from "@m19-board/shared/campaign-type-badge/campaign-type-badge.component";

@Component({
  selector: "app-strategy-formatter",
  imports: [CampaignTypeBadgeComponent],
  template: `
    <div class="flex items-center gap-2">
      @if (values().length > 0) {
        @let value = values()[0];
        <app-campaign-type-badge
          [campaignType]="value.algoMode === AlgoMode.TACOS_TARGET ? CampaignTypeWithTacos.TACOS : value.campaignType"
        />
        <span class="truncate">
          {{ value.name }}
        </span>
      }
      @if (values().length > 1) {
        <span class="text-gray-400">{{ label() }}</span>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyFormatterComponent {
  readonly AlgoMode = AlgoMode;

  readonly values = input.required<StrategyEx[]>();

  readonly label = computed(() => {
    return this.values().length > 1 ? `(+${this.values().length - 1})` : "";
  });
  protected readonly CampaignTypeWithTacos = CampaignTypeWithTacos;
}
